import React from 'react';
import MegaMenu from './MegaMenu';


const GalleryMegaMenu = () => {
  return (
    <>
    {/* <MegaMenu menuName="Gallery" menuParagraph="
Immerse yourself in Unique Technologies' dynamic Gallery, a curated collection of creativity and innovation. From captivating artwork to stunning designs, explore a world of visual delights. Each piece tells a unique story, inviting you to delve into the beauty and diversity of our portfolio. Let our gallery inspire and captivate your imagination." /> */}
    </>
  )
}

export default GalleryMegaMenu
